import { render, staticRenderFns } from "./IconBlockArrow.vue?vue&type=template&id=836470fc"
import script from "./IconBlockArrow.vue?vue&type=script&lang=ts"
export * from "./IconBlockArrow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports